import { defineMessages } from 'react-intl';
export const messages: {
	resultLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	resultLabel: {
		id: 'comment-result.label',
		defaultMessage: 'Comment',
		description: 'Comment label',
	},
});
